module.exports = __webpack_public_path__ + "img/alert.a25da2cf.svg";